import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import { css, StyleSheet } from "aphrodite";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { rootUrl } from "../config.js";

const styles = StyleSheet.create({
	checkMarkIcon: {
		marginRight: 24,
	},
	container: {
		backgroundColor: colors.lightTeal3,
		border: `1px dashed ${colors.purple}`,
		[breakpoints.mobileOnly]: {
			marginBottom: 40,
		},
	},
	header: {
		paddingTop: 16,
		paddingLeft: 16,
		paddingRight: 16,
		paddingBottom: 10,
		fontSize: 60,
		fontWeight: 300,
		letterSpacing: 3,
		lineHeight: 0.92,
		fontFamily: "PopulaireLight",
	},
	item: {
		paddingLeft: 10,
		paddingRight: 10,
		paddingTop: 6,
		paddingBottom: 6,
		display: "flex",
		alignItems: "center",
		borderTop: `1px dashed ${colors.gray2}`,
	},
	itemText: {
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontSize: 15,
		lineHeight: 1.2,
		color: colors.black4,
		flex: 1,
	},
});

export default class ClassDetails extends PureComponent {
	static propTypes = {
		header: PropTypes.string.isRequired,
		items: PropTypes.arrayOf(PropTypes.string).isRequired,
	};

	render() {
		return (
			<div className={css(styles.container)}>
				<div className={css(styles.header)}>{this.props.header}</div>
				{this.props.items.map(item => (
					<div className={css(styles.item)} key={item}>
						<img
							className={css(styles.checkMarkIcon)}
							height="28"
							width="39"
							alt="checkmark"
							src={`${rootUrl}/images/check.png`}
							srcSet={`${rootUrl}/images/check@2x.png 2x, ${rootUrl}/images/check@3x.png 3x`}
						/>
						<div className={css(styles.itemText)}>{item}</div>
					</div>
				))}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ClassDetails.js